import {convertWallBasedPositioningToCoordinates} from '../helpers/stovePositionConverter';

var initialState =
{
    doorWallWidth:"",
    depth: "",
    height: "",
    doorWidth: "",
    doorHeight: 1850,
    doorHandness:"right",
    upGlassHeight:300,
    upGlassEnabled: true,
    leftSideGlassEnabled: true,
    leftSideGlassWidth: 800,
    leftSideGlassHeight: 1000,
    rightSideGlassEnabled: true,
    rightSideGlassWidth: 800,
    rightSideGlassHeight: 1000,
    spaceUnderDoor:120,
    doorFromLeft: 0,
    skipped: false,
    stovePosition: { x: 325 , y: 325 },
    glassMaterial: 1,
    doorSizeConstraints: {
        leftSideGlassMinWidth: 200,
        leftSideGlassMaxWidth: 1000,
        leftSideGlassMinHeight: 200,
        leftSideGlassMaxHeight: 2000,
        rightSideGlassMinWidth: 200,
        rightSideGlassMaxWidth: 1000,
        rightSideGlassMinHeight: 2000,
        rightSideGlassMaxHeight: 2000,
        minUpGlassHeight: 100,
        maxUpGlassHeight: 500,
        allowAddOrRemoveGlass: true
    },
    glassListMaterial:1,
    doorType: "customGlassWall",
    positioningSkipped: false,
    comment:"",
    floorImage:[]
   
}
const measurements = (state = initialState, action) => {
    switch (action.type) {
        case 'ROOM_MEASUREMENTS_UPDATED':
            let stovePosition = { x: action.measurements.doorWallWidth - 325 || 0, y: action.measurements.depth - 325 || 0 };
            let newState = action.measurements;
            newState.stovePosition = stovePosition;
            return { ...state, ...newState }
        case 'DOORMATERIAL_CHANGED':
            return Object.assign({}, state, {
                glassMaterial: action.material
            })
        case 'GLASSLIST_MATERIAL_CHANGED':
            return Object.assign({}, state, {
                glassListMaterial: action.materialId
            })

        case 'MEASUREMENTS_SKIPPED':
            return Object.assign({}, state, {
                skipped: true
            })
        case 'MEASUREMENTS_GIVEN':
            return Object.assign({}, state, {
                skipped: false
            })
        case 'DOORFROMLEFT_UPDATED':
            return Object.assign({}, state, {
                doorFromLeft: action.doorFromLeft
            })
        case 'LEFTSIDEGLASS_HEIGHT_CHANGED':
            return Object.assign({}, state, {
                leftSideGlassHeight: action.height
            })
        case 'STOVEPOSITION_UPDATED':
            return Object.assign({}, state, {
                stovePosition: action.stovePosition
            })
        case 'UPDATE_SAUNACADIMAGE':
            return Object.assign({}, state, {          
                cadImageUpdatePending: true
            })
        case 'SAUNACADIMAGE_UPDATED':
            return Object.assign({}, state, {
                cadImage: action.image,
                cadImageUpdatePending: false
            })
        case 'PLAN_LOADED':   
            return Object.assign({}, state, {
                doorWallWidth: action.plan.saunaWidth,
                depth: action.plan.saunaDepth,
                height: action.plan.saunaHeight,
                doorWidth: action.plan.doorWidth,
                doorFromLeft: action.plan.doorfromLeft,
                stovePosition: convertWallBasedPositioningToCoordinates(action.plan.stoveWall, action.plan.stoveFromLeft, action.plan.saunaWidth, action.plan.saunaDepth)
            })
        case 'DOOR_TYPE_CHANGED':
            return Object.assign({}, state, {
                doorType: action.doorType
            })
        case 'UPDATE_DOORSIZE_CONSTRAINTS':
            return Object.assign({}, state, {
                doorSizeConstraints: action.doorSizeConstraints
            })

        case 'CHANGE_DOOR_HANDNESS':
            return Object.assign({}, state, {
                doorHandness: state.doorHandness == "right" ? "left" : "right"
            })               

        case 'LEFTSIDEGLASS_HEIGHT_CHANGED':
            return Object.assign({}, state, {
                leftSideGlassHeight: action.height
            })
        case 'LEFTSIDEGLASS_WIDTH_CHANGED':
            return Object.assign({}, state, {
                leftSideGlassWidth: action.width
            })
        case 'TOGGLE_LEFTSIDEGLASS':
            return Object.assign({}, state, {
                leftSideGlassEnabled: !state.leftSideGlassEnabled
            })
        case 'RIGHTSIDEGLASS_HEIGHT_CHANGED':
            return Object.assign({}, state, {
                rightSideGlassHeight: action.height
            })
        case 'RIGHTSIDEGLASS_WIDTH_CHANGED':
            return Object.assign({}, state, {
                rightSideGlassWidth: action.width
            })
        case 'TOGGLE_RIGHTSIDEGLASS':
            return Object.assign({}, state, {
                rightSideGlassEnabled: !state.rightSideGlassEnabled
            })
        case 'TOGGLE_UPGLASS':
            return Object.assign({}, state, {
                upGlassEnabled: !state.upGlassEnabled
            })
        case 'DOOR_HEIGHT_CHANGED':
            return Object.assign({}, state, {
                doorHeight: action.height
            })
            case 'SPACE_UNDER_DOOR_CHANGED':
            let change = action.height - state.spaceUnderDoor;
            return Object.assign({}, state, {
                spaceUnderDoor: action.height,
                doorHeight:state.doorHeight-change
            })            
        case 'UP_GLASS_HEIGHT_CHANGED':
            return Object.assign({}, state, {
                upGlassHeight: action.height
            })
        case 'UPDATE_POSITIONING_SKIPPED':
            return Object.assign({}, state, {
                positioningSkipped: action.value 
            });
        default:
            return state;
    }
}
export default measurements
